import FeatherIcon from "feather-icons-react"
import { Button, Checkbox, Dropdown, Input, Table } from "semantic-ui-react"
import './CashFlowHolding.scss'
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CurrencyDropdown from "src/components/general/js/currencyDropdown";
import moment from "moment";
import Cashflow from "src/components/flujocaja(new)";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useWindowDimensions from "src/utils/windowDimension";
import { GetHoldingFlow, GetHoldingFlowStructure } from "src/graphql/cashflowHolding";
import { LoadingCurrencyMessage, LoadingProjectionMessage, LoadingViewMessage } from "src/components/flujocaja(new)/functions";
import { getUpdateHoldingCashFlowStructureNeeded, importUpdateHoldingCashFlowNeeded } from "src/redux/actions/holdingCashFlow";
import HoldingFlow from "./FlowHolding";
import { MergeAreasModal } from "./MergeAreasModal";
import LoadingSpinner from "src/components/general/js/spinnerLoading";

const VIEW_TYPE = {
  day: "day",
  week: "week",
  month: "month",
};

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const CashFlowHolding = ({selectedCompanies}) => {
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.companyList);

  const { updateHoldingCashFlowNeeded, updateHoldingCashFlowStructure } = useSelector(
    (state) => state.holdingCashFlow
  );

  const { openSidebar } = useSelector((state) => state.openSidebar);
  const user = useSelector((state) => state.auth);

  const companyId = selectedCompany.id;
  const defaultView = user?.flowView
    ? user.flowView.find((f) => f?.companyId == companyId)
    : VIEW_TYPE.month;

  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const [nameSelected, setNameSelected] = useState();
  const [tableHeight, setTableHeight] = useState();

  const [checkSwitch, setCheckSwitch] = useState(false);

  const [showAll, setShowAll] = useState(false);
  const [checkSwitchShowProjections, setCheckSwitchShowProjections] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const [updateCompress, setUpdateCompress] = useState(true);
  const [currency, setCurrency] = useState("CLP");
  const [view, setView] = useState(VIEW_TYPE.month);
  const [loadingMsg, setLoadingMsg] = useState("Cargando...");

  const [viewType, setViewType] = useState();

  const Start = useState();
  const End = useState();

  const { height } = useWindowDimensions();

  const [areaFilter, setAreaFilter] = useState('');
  const [filterInputValue, setFilterInputValue] = useState('');

  const { data, fetching: holdingFlowFetching, reexecuteHoldingFlow } = GetHoldingFlow({ companyIds: selectedCompanies , currency, view, showProjections: checkSwitchShowProjections, areaFilter: areaFilter })

  const { data: holdingFlowStructure, reExecuteQuery: reExecuteQueryHoldingFlowStructure } = GetHoldingFlowStructure({ companyIds: selectedCompanies });

  const [mergeAreasModalIsOpen, setMergeAreasModalIsOpen] = useState(false);
  const [mergeAreasModalData, setMergeAreasModalData] = useState();

  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(async () => {
    if (updateHoldingCashFlowNeeded?.value) {
      await delay(500);
      reexecuteHoldingFlow({ requestPolicy: "network-only" });
      dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: null }));
    }
  }, [updateHoldingCashFlowNeeded?.value]);

  useEffect(() => {
    if (!isFirstRender) return;
    setIsFirstRender(false);
  })

  useEffect(async () => {
    if (updateHoldingCashFlowStructure?.value) {
      reExecuteQueryHoldingFlowStructure({ requestPolicy: "network-only" });
      dispatch(getUpdateHoldingCashFlowStructureNeeded({ value: false }));
    }
  }, [updateHoldingCashFlowStructure?.value]);

  useEffect(() => {
    const [_, setStartDate] = Start;

    setStartDate(moment().startOf(view).subtract(1, view).format("YYYY-MM-DD"));
    // dispatch(importOpenSidebar({ show: false }));
    // dispatch(importUpdateCashflowNeeded({ value: false, reload: false }))
    reexecuteHoldingFlow({ requestPolicy: 'network-only' });
  }, [companyId])

  useEffect(() => {
    var lessHeight = document.getElementsByClassName("c-header");
    const res = height - lessHeight[0]?.clientHeight * 2;
    setTableHeight(res);
  }, [height]);

  const downloadFunction = async (name, id) => {
    // const response = await downloadProjection({ companyId, name, id })
    // return response
  }

  const plus = () => {
    if (!data?.getHoldingCashFlow) return null;

    const [startDate, setStartDate] = Start;
    const [endDate, setEndDate] = End;

    if (
      view == VIEW_TYPE.month &&
      moment(endDate) >=
      moment().add(data?.getHoldingCashFlow?.futureMonthsView || 12, view)
    )
      return null;
    setStartDate(
      moment(startDate)
        .startOf(view)
        .add(1, view)
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    setEndDate(
      moment(endDate).endOf(view).add(1, view).format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
  };

  const less = () => {
    if (!data?.getHoldingCashFlow) return null;

    const [startDate, setStartDate] = Start;
    const [endDate, setEndDate] = End;

    if (
      view == VIEW_TYPE.month &&
      moment(startDate) <= moment().subtract(12, view)
    )
      return null;
    setStartDate(
      moment(startDate)
        .startOf(view)
        .subtract(1, view)
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    setEndDate(
      moment(endDate)
        .endOf(view)
        .subtract(1, view)
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
  };

  const addViewTypeParam = (type) => {
    searchParams.set("view_type", type);

    history.push({ search: searchParams.toString() });
  };

  const addCurrencyParam = (type) => {
    searchParams.set("currency", type);

    history.push({ search: searchParams.toString() });
  };

  const addShowProjectionsParam = (_, value) => {
    const showProjections = value?.checked;

    searchParams.set("projections", showProjections);
    history.push({ search: searchParams.toString() });
  };

  useEffect(() => {
    if (
      (!holdingFlowFetching && updateHoldingCashFlowNeeded?.reload === true) ||
      data ||
      holdingFlowStructure?.getFlowStructure
    ) {
      const urlViewType = searchParams.get("view_type");
      const urlCurrency = searchParams.get("currency");
      const urlProjections = searchParams.get("projections") === "true";

      if (!urlViewType) {
        addViewTypeParam(view);
      } else if (urlViewType !== view) {
        onViewChange(urlViewType);
      }

      if (!urlCurrency) {
        addCurrencyParam(currency);
      } else if (urlCurrency !== currency) {
        onCurrencyChange(urlCurrency);
      }

      if (searchParams.get("projections") == null) {
        addShowProjectionsParam("", { checked: checkSwitchShowProjections });
      } else if (urlProjections !== checkSwitchShowProjections) {
        //onChangeSwitchShowProjections(urlProjections);
      }
    }
  }, [
    location.search,
    holdingFlowFetching,
    updateHoldingCashFlowNeeded?.reload,
    data,
    holdingFlowStructure?.getFlowStructure,
  ]);

  const onViewChange = async (value) => {
    addViewTypeParam(value);
    setLoadingMsg(LoadingViewMessage[value]);
    const [_, setStartDate] = Start;
    setView(value);
    setIsLoading(true);
    setStartDate(
      moment().startOf(value).subtract(1, value).format("YYYY-MM-DD")
    );

    dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: true }));
    await new Promise((res) => setTimeout(res, 4000));
    setIsLoading(false);
  };

  const onCurrencyChange = (value) => {
    addCurrencyParam(value);
    setLoadingMsg(LoadingCurrencyMessage[value]);
    const [_, setStartDate] = Start;

    setCurrency(value);
    setStartDate(moment().startOf(view).subtract(1, view).format("YYYY-MM-DD"));
    dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: true }));
  };

  const onChangeSwitchShowProjections = async (_, v) => {
    addShowProjectionsParam(_, v);
    const showProjections = v?.checked;

    setLoadingMsg(LoadingProjectionMessage[String(showProjections)]);
    setCheckSwitchShowProjections(showProjections);
  }

  const handleInputChange = (event) => {
    setFilterInputValue(event.target.value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAreaFilter(filterInputValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [filterInputValue]);

  useEffect(() => {
    if (!mergeAreasModalData) return;

    setMergeAreasModalIsOpen(true);
  }, [mergeAreasModalData])

  return (
    <>
      <div className="tw-flex tw-flex-col tw-gap-[20px]">
        <span
          className="tw-font-semibold tw-text-xl"
        >
          Flujo de caja
        </span>

        <div className="tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-[25px] tw-p-[30px] tw-bg-white tw-rounded-[7px]">

          {
            holdingFlowFetching && isFirstRender
              ?
              <div className="containerTable">
                <div className="flowSpinner">
                  <LoadingSpinner
                    height="60px"
                    afterHeight="60px"
                    afterWidth="60px"
                  />
                  <p className="pt-2">Cargando...</p>
                </div>
                <div
                  className="containerTable__cardPreLoader"
                  style={{ height: "80vh" }}
                ></div>
              </div>
              :
              <>
                <div className="tw-w-full tw-flex tw-justify-between cash-flow-filters flowTableContainer">
                  <section className="tw-w-[315px] tw-flex tw-justify-between">
                    <Dropdown
                      placeholder='Seleccionar una vista'
                      fluid
                      defaultOpen={false}
                      selection
                      onChange={(_, { value }) => onViewChange(value)}
                      defaultValue={view || defaultView?.view}
                      className="!tw-w-[160px]"
                      options={[
                        {
                          key: VIEW_TYPE.month,
                          text: 'Vista Mensual',
                          value: VIEW_TYPE.month,
                        },
                        {
                          key: VIEW_TYPE.week,
                          text: 'Vista Semanal',
                          value: VIEW_TYPE.week,
                        },
                        {
                          key: VIEW_TYPE.day,
                          text: 'Vista Diario',
                          value: VIEW_TYPE.day,
                        },
                      ]}
                    />
                    {/* <Input
                      icon={
                        <i className="icon">
                          <FeatherIcon icon="search" className="icon tw-text-gray-600" size={14.33} />
                        </i>
                      }
                      iconPosition="left"
                      placeholder="Buscar"
                      className="tw-w-[300px] !tw-h-[35px] !tw-text-base"
                      onChange={handleInputChange}
                    /> */}

                    <Button
                      primary
                      onClick={() => setMergeAreasModalIsOpen(true)}
                    >
                      Combinar áreas
                    </Button>
                  </section>

                  <section className="tw-flex tw-items-center">
                    <Checkbox
                      toggle
                      fitted
                      label="Mostrar proyecciones"
                      className="pr-3"
                      onChange={onChangeSwitchShowProjections}
                      checked={checkSwitchShowProjections}
                    />
                    <Checkbox
                      toggle
                      fitted
                      label="Mostrar todas las filas"
                      className="pr-3"
                      defaultChecked={showAll}
                      onChange={(_, v) =>
                        setShowAll(v.checked)}
                    />
                    <Checkbox
                      toggle
                      fitted
                      label="Colapsar"
                      className="pr-3"
                      checked={checkSwitch}
                      onChange={(_, v) => {
                        setCheckSwitch(v?.checked)
                        setUpdateCompress(true)
                      }}
                    />
                    <CurrencyDropdown
                      onChange={onCurrencyChange}
                      value={currency}
                      button
                      basic
                    />
                  </section>
                </div>

                {/* <FlowHolding
                  holdingCashFlow={data?.getHoldingCashFlow}
                  start={Start}
                  end={End}
                  view={view}
                  plus={plus}
                  less={less}
                /> */}
                <HoldingFlow
                  getFlow={data?.getHoldingCashFlow}
                  flowStructure={holdingFlowStructure?.getHoldingFlowStructure}
                  view={view || defaultView?.view}
                  setNameSelected={setNameSelected}
                  tableHeight={tableHeight}
                  loading={(holdingFlowFetching) || isLoading}
                  loadingMsg={loadingMsg}
                  start={Start}
                  end={End}
                  checkSwitch={checkSwitch}
                  setCheckSwitch={setCheckSwitch}
                  updateCompress={updateCompress}
                  setUpdateCompress={setUpdateCompress}
                  showAll={showAll}
                  isHolding={true}
                  plus={plus}
                  less={less}
                  handleInputChange={handleInputChange}
                  setMergeAreasModalData={setMergeAreasModalData}
                />
                {/* <Cashflow
                  getFlow={data?.getHoldingCashFlow}
                  flowStructure={holdingFlowStructure?.getHoldingFlowStructure}
                  view={view || defaultView?.view}
                  setNameSelected={setNameSelected}
                  tableHeight={tableHeight}
                  loading={(holdingFlowFetching) || isLoading}
                  loadingMsg={loadingMsg}
                  start={Start}
                  end={End}
                  checkSwitch={checkSwitch}
                  setCheckSwitch={setCheckSwitch}
                  updateCompress={updateCompress}
                  setUpdateCompress={setUpdateCompress}
                  showAll={showAll}
                  isHolding={true}
                  plus={plus}
                  less={less}
                /> */}
              </>
          }
        </div>

      </div>

      <MergeAreasModal
        modalIsOpen={mergeAreasModalIsOpen}
        incomeList={holdingFlowStructure?.getHoldingFlowStructure[0].report.INCOME}
        expenseList={holdingFlowStructure?.getHoldingFlowStructure[0].report.EXPENSE}
        holdingCashFlowId={data?.getHoldingCashFlow?.id}
        setMergeAreasModalIsOpen={setMergeAreasModalIsOpen}
        reexecuteHoldingFlow={reexecuteHoldingFlow}
        mergeAreasModalData={mergeAreasModalData}
        setMergeAreasModalData={setMergeAreasModalData}
        reExecuteQueryHoldingFlowStructure={reExecuteQueryHoldingFlowStructure}
      />
    </>
  )
}